// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { BudgetOut } from './budgetOut.zod.ts';
import { UsageBucket } from './usageBucket.zod.ts';
import { UsageTotals } from './usageTotals.zod.ts';

export const UsageOut = zod.object({
  "budget": BudgetOut,
  "by_day": zod.array(UsageBucket),
  "by_model": zod.array(UsageBucket),
  "by_month": zod.array(UsageBucket),
  "by_process": zod.array(UsageBucket),
  "by_user": zod.array(UsageBucket),
  "month": zod.string(),
  "period": zod.string(),
  "totals": UsageTotals
});

export type UsageOut = zod.input<typeof UsageOut>;
export type UsageOutOutput = zod.output<typeof UsageOut>;
